import React from 'react';
import { withTranslation } from 'react-i18next';
import helper from '../../../../utils/helper';
import Backend from '../../../Layouts/Backend';
import { Alert, NavButton, Dropdown, Loading } from '../../../UI/Common';
import { FormGroup, CustomInput } from 'reactstrap';
import Datagrid from '../../../UI/Datagrid';
import { cloneDeep } from 'lodash';
import ReactSelect from '../../../UI/ReactSelect';

function MobileConfigurationsPage({
  t,
  columns,
  defaultSorted,
  departments,
  deptId,
  mobileConfigs,
  ...props
}) {
  const roleNames =
    JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
  const isAdmin = roleNames.includes('admin') || roleNames.includes('Admin');
  const [onlyPub, setOnlyPub] = React.useState(false);
  function getData() {
    return onlyPub
      ? mobileConfigs.filter((dat) => dat.accessibleTypes)
      : mobileConfigs;
  }
  if (mobileConfigs === null) {
    return (
      <Backend>
        <div className="content-inner">
          <Loading />
        </div>
      </Backend>
    );
  }
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={props.errors} />
        <ReactSelect
          required
          isClearable={false}
          containerStyle={{ width: '30%' }}
          isDisabled={!isAdmin}
          label="Department"
          options={departments}
          value={deptId}
          onChange={({ value }) => props.onChangeDept(value)}
          valueKey="id"
          labelKey="name"
        />
        <div className="d-flex flex-row justify-content-between align-items-end">
          <NavButton
            id="new-m-config-btn"
            to={`/configure/mobile-configurations/new-mobile-configuration?deptId=${deptId}`}
          >
            <i className="md-icon">add</i>
            {t('New Mobile Configuration')}
          </NavButton>
          <FormGroup style={{ marginBottom: 10 }}>
            <CustomInput
              type="checkbox"
              id="pub-only-checkbox"
              label={t('Public Only')}
              checked={onlyPub}
              onChange={(e) => setOnlyPub(e.target.checked)}
            />
          </FormGroup>
        </div>
        <Datagrid
          datagridProps={{
            keyField: 'id',
            data: getData(),
            columns,
            loading: props.loading,
            defaultSorted,
          }}
          ctxMenuOptions={props.ctxMenuOptions}
          exportProps={{
            fileName: 'MobileConfigurations',
          }}
        />
      </div>
    </Backend>
  );
}

export default withTranslation('app')(MobileConfigurationsPage);
